module.exports = __webpack_public_path__ + "img/candle-2.d39ac806.png";